import React from "react";
import backgroung from '../assets/images/404-error.png';
import backgroung1 from '../assets/images/hero-bg-1.7e93179dada839706f60.webp';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div
      id="kt_body"
      className="auth-bg bgi-size-cover bgi-position-center bgi-no-repeat"
      style={{
        backgroundImage:
          "url("+backgroung1+")",
            
      }}
    >
      <div className="d-flex flex-column flex-root">
        <div className="d-flex flex-column flex-center flex-column-fluid py-12">
          <div className="d-flex flex-column flex-center text-center p-10">
            <div className="card card-flush w-lg-650px">
              <div className="card-body py-15 py-lg-20" style={{display:'flex', flexDirection:'column', alignItems:'center'}}>
                <h1 className="fw-bolder fs-2hx text-gray-900 mb-4">Oops!</h1>
                <div className="fw-semibold fs-6 text-gray-500 mb-7">
                  We can't find that page.
                </div>
                <div className="mb-3">
                  <img
                    src={backgroung}
                    className="mw-100 mh-300px theme-light-show"
                    alt="404 Error"
                  />
                </div>
                <div className="mb-0">
                  <Link 
                    to="/"
                    className="btn mt-5 home-btn"
                  >
                    Return Home
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;